import React from 'react'

/**
* @author
* @function ContactUS
**/

export const ContactUS = (props) => {
  return(
    <div></div>
   )
  }
